<template lang="pug">

  form-group-row(:form="form", :label="label", name="gender", required)
    div(:class="maleClass")
      input#addiesaasUserInputGenderMaleRadio(v-model="form.gender", type="radio", value="m", name="gender")
      label(for="addiesaasUserInputGenderMaleRadio") {{ maleLabel }}
    div(:class="femaleClass")
      input#addiesaasUserInputGenderFemaleRadio(v-model="form.gender", type="radio", value="f", name="gender")
      label(for="addiesaasUserInputGenderFemaleRadio") {{ femaleLabel }}
    input.form-control(type="hidden", :class="{'is-invalid': form.errors.has('gender')}")

</template>

<script>

export default {
  name: 'user-input-gender',

  props: {
    label: {
      type: String,
      default: 'Gender',
    },
    maleLabel: {
      type: String,
      default: 'Male',
    },
    femaleLabel: {
      type: String,
      default: 'Female',
    },
    maleClass: {
      type: String,
      default: '',
    },
    femaleClass: {
      type: String,
      default: '',
    }
  },

  data: () => ({
    form: null,
  }),

  async created() {
    this.form = this.$parent.form;
    this.form.gender = this.$parent.user ? this.$parent.user.meta.gender : '';
  },
}

</script>
